import { FormHelperText, TextField, TextFieldProps } from '@mui/material'

import { Controller } from 'react-hook-form'

import { FormInputProps } from './FormInputProps'

import styles from './styles.module.scss'

type FormInputTextProps = FormInputProps & TextFieldProps

export const FormInputText = ({
  name,
  control,
  defaultValue,
  validate,
  label,
  type,
  id,
  style,
  required,
  inputError,
  ...rest
}: FormInputTextProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState }) => {
        return (
          <>
            <TextField
              fullWidth
              error={inputError || (fieldState.error ? true : false)}
              type={type || 'text'}
              label={label}
              id={id}
              value={value || ''}
              name={name}
              size="small"
              onChange={onChange}
              style={style}
              required={required}
              margin="normal"
              variant="outlined"
              sx={{ width: '100%' }}
              {...rest}
            />
            {fieldState.error && (
              <div className={styles.containerError}>
                <FormHelperText error sx={{ lineHeight: '1rem', marginTop: 0 }}>
                  *{fieldState.error.message}
                </FormHelperText>
              </div>
            )}
          </>
        )
      }}
      defaultValue={defaultValue}
      rules={validate}
    />
  )
}
